import { Box, DialogContent, Grid, styled } from '@mui/material';

export const SubTitleContainer = styled(Box)`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 32px;
  flex-wrap: wrap;
`;

export const StyledDialogContent = styled(DialogContent)(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '36px',
}));

export const StyledGrid = styled(Grid)(({ theme }) => ({
  flex: 1,
  backgroundColor: theme.palette.brand?.whitesmoke,
  border: `1px solid ${theme.palette.brand?.disable}`,
  minHeight: '50vh',
  position: 'relative',
}));

export const StyledProductImage = styled('img')(
  () => ` 
    object-fit: contain;
    background-position: bottom;
    background-repeat: no-repeat;
    border-radius: 7px;
    max-height: 75vh;
    `,
);
export const StyledProductContainer = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  minHeight: '75vh',
}));
export const StyledSectionTypes = styled(Box)(() => ({
  display: 'inline-block',
  marginRight: '8px',
}));

export const AssemblyLayoutWrapper = styled(Box)(() => ({
  height: '100%',
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));
